import {faPlus, faUpload} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Space} from 'antd';

import {appRoute} from '../../../../../app-route';
import {NavigationLink} from '../../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {useSystem} from '../../../../../provider/system/system-hook';

import * as styles from './add-review-button.module.scss';

export function AddReviewButton(): JSX.Element {
    const {screen} = useSystem();
    const {getLocalizedString} = useLocale();

    return (
        <Space.Compact className={styles.AddReviewButton_space}>
            <NavigationLink
                className={styles.AddReviewButton_link}
                isTargetBlank
                to={appRoute.reviewsManagementCreateReview.path}
            >
                <Button icon={screen.isMobile ? <FontAwesomeIcon icon={faPlus} /> : null} size="middle" type="primary">
                    {!screen.isMobile && <Locale stringKey="REVIEW__ADD_REVIEW__TOOLTIP" />}
                </Button>
            </NavigationLink>
            <NavigationLink
                className={styles.AddReviewButton_link}
                isTargetBlank
                to={appRoute.reviewsManagementImportReviews.path}
            >
                <Button
                    aria-label={getLocalizedString('REVIEW__ADD_REVIEW__UPLOAD_FROM_FILE')}
                    icon={<FontAwesomeIcon icon={faUpload} />}
                    size="middle"
                />
            </NavigationLink>
        </Space.Compact>
    );
}
